import React from 'react';
import { brandConfig } from '../config/brand';

function BrandLogo({ className = '' }) {
  return (
    <img
      className={`brand-logo ${className}`}
      src={brandConfig.logoSrc}
      alt="South Eastern Bakery"
      width="320"
      height="110"
      loading="eager"
      decoding="async"
    />
  );
}

export default BrandLogo;